module.exports = __webpack_public_path__ + "static/icons/icon-caret-down-7bfb8e362361c50aa7d20e6aae1259ea.svg";